import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const DisclaimerModal = () => {
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    // Check if user has already acknowledged the disclaimer
    const disclaimerAcknowledged = localStorage.getItem('disclaimerAcknowledged');
    if (!disclaimerAcknowledged) {
      setShowModal(true);
    }
  }, []);

  const handleAccept = () => {
    // Store acknowledgment in localStorage
    localStorage.setItem('disclaimerAcknowledged', 'true');
    localStorage.setItem('disclaimerAcknowledgedDate', new Date().toISOString());
    setShowModal(false);
  };

  if (!showModal) return null;

  return (
    <div className="disclaimer-modal-overlay">
      <div className="disclaimer-modal">
        <div className="disclaimer-modal-content">
          <h2 className="disclaimer-modal-title">⚠️ Important Notice</h2>
          
          <div className="disclaimer-modal-body">
            <h3>Educational Use Only - Not Financial Advice</h3>
            <p>
              Bitcoin Wealth Builder provides tools and calculators for <strong>educational purposes only</strong>. 
              All content, calculations, and AI-generated analyses are not financial, investment, legal, or tax advice.
            </p>
            
            <div className="disclaimer-modal-warnings">
              <div className="disclaimer-warning-item">
                <span className="warning-icon">📊</span>
                <span>Projections are based on historical data and assumptions</span>
              </div>
              <div className="disclaimer-warning-item">
                <span className="warning-icon">⚡</span>
                <span>Bitcoin is highly volatile and speculative</span>
              </div>
              <div className="disclaimer-warning-item">
                <span className="warning-icon">💰</span>
                <span>You could lose your entire investment</span>
              </div>
              <div className="disclaimer-warning-item">
                <span className="warning-icon">👤</span>
                <span>Always consult a licensed financial advisor</span>
              </div>
            </div>

            <p className="disclaimer-modal-footer-text">
              By continuing, you acknowledge that you understand these limitations and accept full responsibility 
              for your investment decisions.
            </p>
          </div>
          
          <div className="disclaimer-modal-actions">
            <button 
              onClick={handleAccept}
              className="disclaimer-accept-btn"
            >
              I Understand & Accept
            </button>
            <Link 
              to="/disclaimer" 
              className="disclaimer-full-link"
            >
              Read Full Disclaimer
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DisclaimerModal;